<template>
	<!-- 菜单的最后一级 -->
  <el-menu-item v-if="!data.children || data.children.length === 0" :index="data.data.id+''">
    <i v-if="data.parentId === 0" :class="getIcon(data.data?.menuIcon)"></i>
    {{ data.name }}
  </el-menu-item>
	<!-- 菜单目录 -->
  <el-submenu v-else :index="data.id.toString()">
    <template slot="title">
        <i :class="getIcon(data.data?.menuIcon)"></i> {{ data.name }}
    </template>
    <template v-for="item in data.children">
    <SubMenu :data="item" :key="item.id"></SubMenu>
    </template>

    <!-- <el-submenu :index="data.id">
      <template slot="title"><span>慢病</span></template>
      <el-menu-item  :index="data.id">糖尿病糖尿病糖尿病糖尿病糖尿病糖尿病</el-menu-item>
    </el-submenu> -->

  </el-submenu>

</template>

<script>
export default {
  name: 'SubMenu',
  props: {
    data: Object,
  },
  methods: {
    getIcon(icon) {
      switch (+icon) {
        case 1: return 'icon-work';
        case 2: return 'icon-user2';
        case 3: return 'icon-chart';
        case 4: return 'icon-setting';
      }
    }
  }
}
</script>